import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers } = FiIcons;

function ChildSwitcher({ children, selectedChildId, onSelectChild }) {
  return (
    <div className="child-switcher" aria-label="Choose a child">
      <span className="child-switcher-label">
        <SafeIcon icon={FiUsers} />
        Children
      </span>

      <div className="child-switcher-options">
        {children.map((child) => {
          const isActive = child.id === selectedChildId;

          return (
            <button
              aria-pressed={isActive}
              className={`child-option ${isActive ? 'active' : ''}`}
              key={child.id}
              onClick={() => onSelectChild(child.id)}
              type="button"
            >
              <span className="child-option-avatar">{child.initials}</span>
              <span className="child-option-copy">
                <strong>{child.name}</strong>
                <small>{child.grade} grade</small>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ChildSwitcher;